import { isWindowAvailable } from 'constants/is-window-available';

export const waitFor = (delay: number) =>
  new Promise(resolve => setTimeout(resolve.bind(null, delay), delay));

export const requestIdleCallback = (
  callback: IdleRequestCallback,
  options?: IdleRequestOptions,
) => {
  if (isWindowAvailable && 'requestIdleCallback' in window) {
    return window.requestIdleCallback(callback, options);
  }

  return setTimeout(callback, 0);
};
